import React from 'react';
import ShipmentsTable from './shipmentsTable';

const ReconDashboard = (props) => {
  return (
    <div>
      <ShipmentsTable createBtnClass="create-job-button" />
    </div>
  );
};

export default ReconDashboard;
